import { useBranding, useBrandingHostname } from '@/hooks/use-branding'

import { EDUNODES_HOME_URL } from '@/constant/edunodes'
import { getTenantFromWindow, shouldShowEdunodesPoweredBy } from '@/utils/tenant.utils'

export default function EdunodesPoweredBy() {
  const { isFsdsDomain } = useBranding()
  const hostname = useBrandingHostname()
  const runtimeHostname =
    typeof window !== 'undefined' && window.location.hostname
      ? window.location.hostname
      : hostname
  const tenantSubdomain =
    typeof window !== 'undefined' ? getTenantFromWindow() : 'default'

  if (
    !shouldShowEdunodesPoweredBy(runtimeHostname, {
      isFsdsDomain,
      tenantSubdomain,
    })
  ) {
    return null
  }

  return (
    <p className="w-full text-center text-xs text-muted-foreground sm:text-right">
      Powered by{' '}
      <a
        href={EDUNODES_HOME_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-foreground/80 underline-offset-2 hover:text-primary hover:underline"
      >
        Edunodes
      </a>
    </p>
  )
}
